import { ReactNode } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'

const ContentSubtitle = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <p className={cn(styles.content__subtitle, className)}>{children}</p>
}

export default ContentSubtitle
